import { Card, CardContent, CardHeader, CardTitle } from '@/ui/card';
import { Button } from '@/ui/button';
import { Mail, Phone, HelpCircle, Book, Users } from 'lucide-react';

export default function Support() {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow rounded-lg">
          <div className="px-6 py-8">
            <div className="mb-8 text-center">
              <h1 className="text-3xl font-bold text-gray-900 mb-4">Centro Assistenza</h1>
              <p className="text-gray-600">
                Siamo qui per aiutarvi! Trovate le risposte alle domande più comuni o contattate il nostro team di supporto.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
              <Card className="text-center">
                <CardContent className="pt-6">
                  <Mail className="w-12 h-12 text-blue-600 mx-auto mb-4" />
                  <h3 className="text-lg font-semibold mb-2">Supporto Email</h3>
                  <p className="text-gray-600 mb-4">Assistenza via email entro 24 ore</p>
                  <Button variant="outline" className="w-full">
                    <Mail className="w-4 h-4 mr-2" />
                    info@baetorra.com
                  </Button>
                </CardContent>
              </Card>

              <Card className="text-center">
                <CardContent className="pt-6">
                  <Phone className="w-12 h-12 text-green-600 mx-auto mb-4" />
                  <h3 className="text-lg font-semibold mb-2">Supporto Telefonico</h3>
                  <p className="text-gray-600 mb-4">Parlate direttamente con il nostro team</p>
                  <Button variant="outline" className="w-full">
                    <Phone className="w-4 h-4 mr-2" />
                    340 382 7753
                  </Button>
                </CardContent>
              </Card>
            </div>

            <div className="space-y-8">
              <Card>
                <CardHeader>
                  <CardTitle className="flex items-center">
                    <HelpCircle className="w-5 h-5 mr-2" />
                    Domande Frequenti
                  </CardTitle>
                </CardHeader>
                <CardContent className="space-y-6">
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Come effettuo una prenotazione?</h4>
                    <p className="text-gray-700">
                      Accedete alla piattaforma con le vostre credenziali di agenzia, selezionate il servizio 
                      desiderato, verificate disponibilità e tariffe, inserite i dati del cliente e confermate 
                      la prenotazione. Riceverete immediatamente una conferma con voucher.
                    </p>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Posso modificare o cancellare una prenotazione?</h4>
                    <p className="text-gray-700">
                      Sì, potete modificare o cancellare le prenotazioni secondo le policy del fornitore. 
                      Accedete alla sezione "Prenotazioni" per gestire le vostre pratiche. Le modifiche 
                      e cancellazioni possono essere soggette a penali secondo i termini contrattuali.
                    </p>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Come funziona il sistema di pagamento B2B?</h4>
                    <p className="text-gray-700">
                      Lavoriamo con condizioni di pagamento dedicate alle agenzie: bonifico bancario, 
                      addebito in conto corrente o carte di credito aziendali. I termini di pagamento 
                      sono concordati contrattualmente (es. 30-60 giorni dalla data fattura).
                    </p>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Come ricevo conferma e voucher?</h4>
                    <p className="text-gray-700">
                      Dopo la conferma della prenotazione, ricevete immediatamente via email la conferma 
                      con voucher da fornire al cliente. Tutti i documenti sono disponibili anche nella 
                      sezione "Le Mie Prenotazioni" della piattaforma.
                    </p>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Come contatto il fornitore del servizio?</h4>
                    <p className="text-gray-700">
                      I contatti diretti del fornitore sono inclusi nel voucher di prenotazione. 
                      Per assistenza urgente o problematiche, potete sempre contattare il nostro 
                      supporto che farà da intermediario con il fornitore.
                    </p>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle className="flex items-center">
                    <Book className="w-5 h-5 mr-2" />
                    Come Iniziare
                  </CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Nuovi sulla piattaforma?</h4>
                    <p className="text-gray-700">
                      Benvenuti! La nostra piattaforma B2B semplifica la gestione delle prenotazioni 
                      per agenzie di viaggio. Dopo l'attivazione del vostro account aziendale, 
                      potrete accedere a tariffe preferenziali e gestire le prenotazioni dei vostri clienti.
                    </p>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Configurazione Account Agenzia</h4>
                    <p className="text-gray-700">
                      Il vostro account viene attivato dopo la verifica dei documenti aziendali 
                      (licenza agenzia, partita IVA, referenze bancarie). Una volta approvato, 
                      avrete accesso completo alla piattaforma con le vostre tariffe negoziate.
                    </p>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle className="flex items-center">
                    <Users className="w-5 h-5 mr-2" />
                    Fornitori di Servizi
                  </CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Interessati a diventare partner?</h4>
                    <p className="text-gray-700">
                      Unitevi alla nostra rete di fornitori e raggiungete più agenzie di viaggio. 
                      Contattate il nostro team commerciale per scoprire le opportunità di partnership 
                      e le condizioni contrattuali per hotel, tour operator e fornitori di servizi turistici.
                    </p>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Supporto Fornitori</h4>
                    <p className="text-gray-700">
                      Offriamo supporto dedicato ai nostri partner: account management, assistenza 
                      tecnica per l'integrazione, formazione sull'uso della piattaforma e supporto 
                      marketing per aumentare la visibilità dei vostri servizi.
                    </p>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardHeader>
                  <CardTitle>Informazioni di Contatto</CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2">Orari di Assistenza</h4>
                      <p className="text-gray-700">Lunedì - Venerdì: 9:00 - 18:00</p>
                      <p className="text-gray-700">Sabato: 9:00 - 13:00</p>
                      <p className="text-gray-700">Domenica: Chiuso</p>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2">Assistenza Urgente</h4>
                      <p className="text-gray-700">
                        Per problematiche urgenti su prenotazioni attive, contattate il nostro 
                        supporto al 340 382 7753 (orari di ufficio)
                      </p>
                    </div>
                  </div>
                  <div className="mt-6 pt-6 border-t border-gray-200">
                    <p className="text-gray-700">
                      <strong>Baetorra</strong><br />
                      di Emanuel Francisco Barrocoso Daun<br />
                      Via Baronia 4<br />
                      07051 Budoni (SS)<br />
                      P. IVA: 01599490917
                    </p>
                  </div>
                </CardContent>
              </Card>

              <div className="text-center py-8">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">
                  Serve ancora aiuto?
                </h3>
                <p className="text-gray-600 mb-6">
                  Non trovate quello che cercate? Il nostro team è sempre pronto ad assistervi.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <Button className="bg-blue-600 hover:bg-blue-700">
                    <Mail className="w-4 h-4 mr-2" />
                    info@baetorra.com
                  </Button>
                  <Button variant="outline" className="border-green-600 text-green-600 hover:bg-green-50">
                    <Phone className="w-4 h-4 mr-2" />
                    340 382 7753
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}